import { h } from "vue";
import type { IconSet, IconProps, IconAliases } from "vuetify";
import { icons as vuetifyIcons } from "@/application/plugins/icons/vuetify";
import { icons as appIcons } from "@/application/plugins/icons/app";

const icons = {
  ...vuetifyIcons,
  ...appIcons,
} as IconAliases;

export const aliases = Object.keys(icons).reduce((acc, key) => {
  return { ...acc, [key]: key };
}, {});

export const lucideIcons: IconSet = {
  component: (props: IconProps) => h(icons[props.icon as keyof typeof icons]),
};
